import styled from '@emotion/styled';
import { color, COLOR_VARIANTS, Typography } from '@tajawal/ct-web-design-system';

const SearchCardPricing = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  width: 249px;
  border-left: 1px solid ${color(COLOR_VARIANTS.GAINSBORO)};

  a {
    padding: 0;
  }
`;

const Pricing = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SearchCardPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  justify-content: center;
`;

const Discount = styled.div`
  font-size: 12px;
  text-decoration: line-through;
  color: ${color(COLOR_VARIANTS.CORALPRESSED)};
`;

const Price = styled(Typography)`
  & > div > span {
    font-size: 26px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

const CheckPricesButton = styled.div`
  width: 100%;
  .MuiLoadingButton-root > .MuiButton-endIcon {
    width: 16px;
    height: 16px;
  }
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default {
  SearchCardPricing,
  SearchCardPrice,
  Pricing,
  Discount,
  Price,
  CheckPricesButton,
};
